import * as form from '../form';
import * as validator from './validator';

class Form extends form.Form {
  private readonly validators = [new validator.TextDateValidator(this.form)];
  protected override checkValidity() {
    return this.validators.every(validator => validator.checkValidity());
  }
}

form.Form.register('password', Form);
